module.exports = __webpack_public_path__ + "img/image9.3a48ebe5.jpg";